import { createContext, useContext } from 'react';

// Root element of the OpenX Agent window, used as the portal container for dialogs scoped to the window.
export const OpenXAgentModalContainerContext = createContext<HTMLElement | null>(null);

export const useOpenXAgentModalContainer = () => useContext(OpenXAgentModalContainerContext);
